"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdGrid_1 = require("views/stdGrid");
const globals_1 = require("models/globals");
const boutons_1 = require("../../outils/boutons");
const listeChrono_1 = require("../../models/listeChrono");
class listeChrono extends stdGrid_1.default {
    constructor(app, name) {
        super(app, name, {
            moduleName: "listeChrono",
            datatableName: "facturesChronoDatatable",
            columns: listeChrono_1.listeChronoColumns,
            title: (0, globals_1._)("Factures chronologie"),
            boutons: [boutons_1.ouvrirButton],
            urlData: globals_1.phpPath + "factures.php?option=listeChrono"
        });
    }
    ouvrir() {
        let idDoc = this.getSelectedIdDoc();
        if (idDoc > 0) {
            let menuGauche = $$("menu");
            menuGauche.unselectAll();
            window.location.href = "#!/pgiLayout/factures?unid=" + idDoc;
        }
    }
    init() {
        this.currentGrid = $$(this.datatableName);
        // @ts-ignore
        this.currentGrid.config.footer = true;
        let me = this;
        this.currentGrid.attachEvent("onItemDblClick", function () {
            me.ouvrir();
        });
        let menu = this.$$("stdGridMenu");
        menu.attachEvent("onMenuItemClick", function (id, e, node) {
            switch (id) {
                case "ouvrirButton":
                    me.ouvrir();
                    break;
            }
        });
    }
    ready() {
        let menu = this.$$("stdGridMenu");
        menu.hideMenuItem("ouvrirButton");
        if ((globals_1.lv2.droits).includes("facturation.read")) {
            menu.showMenuItem("ouvrirButton");
        }
    }
}
exports.default = listeChrono;
